import { render, staticRenderFns } from "./LKAdmin.vue?vue&type=template&id=23abd3f0&scoped=true&"
import script from "./LKAdmin.vue?vue&type=script&lang=js&"
export * from "./LKAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23abd3f0",
  null
  
)

export default component.exports